'use client'
import React, {useEffect} from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {Img} from "@/components/Img";
import {} from "@/styles/globalStyleVars";
import Link from "next/link";



const AddressMap = ({img, text, title,data,imgMobile}) => {
    const isWideScreen = typeof window !== 'undefined' && window.innerWidth > 1680;


    return (
        <StyledAddress className='address-map pt-100 pb-100' id={'address'}>
            <Container>
                {
                    isWideScreen ?
                        <Row>
                            <Col md={7}>
                                <div className="address-map__map">
                                    <Link href={data?.images?.list?.[0]?.short_title} target={'_blank'}/>
                                    <img src={data?.images?.list?.[0]?.cdn_path} alt="map"/>
                                </div>
                            </Col>
                            <Col md={5}>
                                <div className="address-map__address">
                                    <div className="address-map__address__find">
                                        <h3>{data?.posts?.list?.[0]?.data?.title}</h3>
                                        <p>Address</p>
                                        <a href={data?.posts?.list?.[0]?.data?.description} target={'_blank'}>{data?.posts?.list?.[0]?.data?.short_desc}</a>
                                    </div>
                                    <div className="address-map__address__connect">
                                        <h3>{data?.posts?.list?.[1]?.data?.title}</h3>
                                        <div className="left-right">
                                            <div className="left">
                                                <p>Phone</p>
                                                <a href={`tel:${data?.posts?.list?.[1]?.data?.short_desc}`}>{data?.posts?.list?.[1]?.data?.short_desc}</a>
												<a href={`tel:${data?.posts?.list?.[1]?.data?.subtitle}`}>{data?.posts?.list?.[1]?.data?.subtitle}</a>
								
                                                <p></p>
                                            </div>
                                            <div className="right">
                                                <p>Email</p>
                                                <a href={`mailto:${data?.posts?.list?.[1]?.data?.description}`}>{data?.posts?.list?.[1]?.data?.description}</a>
                                                <p></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row> :
                        <Row>
                            <Col md={6}>
                                <div className="address-map__map">
                                    <Link href={data?.images?.list?.[0]?.short_title} target={'_blank'}/>
                                    <img src={data?.images?.list?.[0]?.cdn_path} alt="map"/>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="address-map__address">
                                    <div className="address-map__address__find">
                                        <h3>{data?.posts?.list?.[0]?.data?.title}</h3>
                                        <p>Address</p>
                                        <a href={data?.posts?.list?.[0]?.data?.description} target={'_blank'}>{data?.posts?.list?.[0]?.data?.short_desc}</a>
                                    </div>
                                    <div className="address-map__address__connect">
                                        <h3>{data?.posts?.list?.[1]?.data?.title}</h3>
                                        <div className="left-right">
                                            <div className="left">
                                                <p>Phone</p>
                                                <a href={`tel:${data?.posts?.list?.[1]?.data?.short_desc}`}>{data?.posts?.list?.[1]?.data?.short_desc}</a>
												<a href={`tel:${data?.posts?.list?.[1]?.data?.subtitle}`}>{data?.posts?.list?.[1]?.data?.subtitle}</a>
                                                <p></p>
                                            </div>
                                            <div className="right">
                                                <p>Email</p>
                                                <a href={`mailto:${data?.posts?.list?.[1]?.data?.description}`}>{data?.posts?.list?.[1]?.data?.description}</a>
                                                <p></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                }
            </Container>
        </StyledAddress>
    );
};


const StyledAddress = styled.section`
    .address-map {
        &__map {
            position: relative;
            height: 100%;
            width: 100%;
            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                z-index: 1;
                border-radius: 10px;
            }
            a{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 2;
            }
            @media (min-width: 1680px) {
                height: 100%;
                width: 100%;
            }
            @media(max-width: 768px){
                padding-top: calc(600 / 570 * 100%);
            }
            
        }
        &__address{
            display: flex;
            flex-direction: column;
            gap: 20px;
            h3{
                font-size: 40px;
                line-height: 50px;
                font-weight: 800;
                color: #FFF;
                margin-bottom: 30px;
            }
            p{
                font-size: 16px;
                line-height: 24px;
                font-weight: 300;
                color: #FFF;
                margin-bottom: 10px;
            }
            a{
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #FFF;
            }
            &__find{
                padding: 60px 40px;
                background-color: #978C21;
                border-radius: 10px;
                a{
                    width: 50%;
                    display: block;
                }
            }
            &__connect{
                padding: 60px 40px;
                background-color: #3C3C3B;
                border-radius: 10px; 
                .left-right{
                    display: flex;
                    gap: 70px;
					.left{
					a{
					margin-bottom: 10px;
					display: table-row-group;
                    
                }
            }
            @media (max-width: 1500px) {
                a{
                    width: 70%;
                }
            }
            @media (max-width: 1200px) {
                a{
                    width: 80%;
                }
            }
            @media(max-width: 767px){
                margin-top: 30px;
                h3{
                    font-size: 28px;
                    line-height: 36px;
                }
                a{
                    width: 100%;
                }
                .left-right{
                    flex-direction: column;
                    gap: 30px;
                }
            }
        }
    }
    a{
        &:hover{
            color: #FFF !important;
        }
    }
    @media(min-width: 1680px){
        a,p{
            font-size: 18px;
            line-height: 27px;
        }
    }
    @media(max-width: 1024px){
        .left-right{
            gap: 30px !important;
        }
    }
    @media(max-width: 991px){
        .left-right{
            flex-direction: column;
            gap: 30px !important;
        }
    }
`;

export default AddressMap;